<template>
    <ds-dropdown
        disable-scroll
        class="marketing-site-options"
        icons
        position="bottom-end"
        :class="[dropDownClass]"
    >
        <template #default>
            <ds-icon-button name="more-vertical" />
        </template>

        <ul slot="menu" class="dropdown-menu-list">
            <li
                v-if="isPublished || isPublishedWithChanges"
                :data-qa="siteOptions.preview"
                class="option dropdown-menu-item"
                @click="$emit('open-site-preview')"
            >
                <ds-icon class="option-icon" name="external-link" />

                <span>{{ $options.MESSAGE_CONSTANTS.GO_TO_LANDING_PAGE }}</span>
            </li>
            <li
                v-if="isPublished || isPublishedWithChanges"
                :data-qa="siteOptions.copyUrl"
                class="option dropdown-menu-item"
                @click="$emit('copy-site-link')"
            >
                <ds-icon class="option-icon" name="link" />

                <span>{{ $options.MESSAGE_CONSTANTS.COPY_LINK }}</span>
            </li>
            <li
                class="option dropdown-menu-item"
                @click="$emit('edit')"
            >
                <ds-icon class="option-icon" name="edit" />

                <span>{{ $options.MESSAGE_CONSTANTS.EDIT }}</span>
            </li>

            <li
                class="option dropdown-menu-item"
                @click="$emit('copy')"
            >
                <ds-icon class="option-icon" name="copy" />

                <span>{{ $options.MESSAGE_CONSTANTS.COPY }}</span>
            </li>

            <li
                class="option dropdown-menu-item"
                @click.prevent="$emit('rename')"
            >
                <ds-icon class="option-icon" name="rename" />

                <span>{{ $options.MESSAGE_CONSTANTS.RENAME }}</span>
            </li>

            <li
                class="option dropdown-menu-item delete"
                @click.prevent="$emit('delete')"
            >
                <ds-icon name="trash-2" />

                <span>{{ $options.MESSAGE_CONSTANTS.DELETE }}</span>
            </li>
        </ul>
    </ds-dropdown>
</template>

<script>

export const MESSAGE_CONSTANTS = {
    COPY: 'Make a copy',
    DELETE: 'Delete',
    RENAME: 'Rename',
    EDIT: 'Edit',
    GO_TO_LANDING_PAGE: 'Go to landing page',
    COPY_LINK: 'Copy Link',
};

export const SITE_STATUS = {
    PUBLISHED: 'ACTIVE',
    PUBLISHED_CHANGES: 'ACTIVE_CHANGES',
    DRAFT: 'DRAFT',
    SAVED: 'SAVED',
};

export const SITE_OPTIONS = {
    preview: 'preview-option',
    copyUrl: 'copy-url-option',
    duplicate: 'duplicate-options',
    delete: 'delete-option',
    edit: 'edit-option',
    rename: 'rename-options',
};

export default {
    MESSAGE_CONSTANTS,
    SITE_STATUS,
    SITE_OPTIONS,
    props: {
        templateId: {
            type: String,
            defaultValue: '',
        },
        siteStatus: String,
    },

    computed: {
        siteOptions() {
            return SITE_OPTIONS;
        },
        isPublished() {
            return this.siteStatus === SITE_STATUS.PUBLISHED;
        },

        isPublishedWithChanges() {
            return this.siteStatus === SITE_STATUS.PUBLISHED_CHANGES;
        },
        dropDownClass() {
            switch (this.siteStatus) {
            case SITE_STATUS.DRAFT:
                return 'site-unpublished';
            case SITE_STATUS.PUBLISHED:
                return 'site-published';
            case SITE_STATUS.PUBLISHED_CHANGES:
                return 'site-published-changes';
            default:
                return SITE_STATUS.DRAFT;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    $options-min-width: px-to-rem(250px);
    $options-height-published: px-to-rem(331px);
    $options-height-unpublished: px-to-rem(228px);
    $options-height-published-changes: px-to-rem(279px);
    .marketing-site-options ul.dropdown-menu-list {
        margin-top: 0;
        margin-bottom: 0;
        position: absolute;
        box-shadow: 0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12),0 5px 5px -3px rgba(0,0,0,.2);
        border-radius: .75rem;
        z-index: 999;
        background-color: #fff;
    }

    .marketing-site-options {
        --dropdown-minwidth: #{$options-min-width};
        align-self: center;
    }

    .site-unpublished {
        --dropdown-height: #{$options-height-unpublished};
    }

    .site-published {
        --dropdown-height: #{$options-height-published};
    }

    .site-published-changes {
        --dropdown-height: #{$options-height-published-changes};
    }

    .marketing-site-options .option {
        --icon-color: #{$color-gray-700};
        &.delete {
            --icon-color: #{$color-red};
        }
    }

    .preview-container {
        height: px-to-rem(20);
        flex: 1;
        display: flex;
        flex-direction: row;
    }

    .preview-icon {
        flex: 1;
        text-align: end;
    }

    .dropdown-menu.icons  .icon.end-icon {
        margin: 0;
    }
</style>
